import { useEffect, useState } from "react";
import { T } from "react-translator-component";
import { Box, List, ListItem } from "@mui/material";
import LoadingModal from "../../../../components/LoadingModal";
import { useAppDispatch } from "../../../../redux/store";
import { setErrorObj } from "../../../redux/errorReducer";
import apiServices from "../../../services/apiServices";
import DisplayModal from "../../DisplayModal";
import CommentDetail from "./CommentDetail";

interface Props {
  open: boolean;
  post: any;
  highlightWords: string[];
  closeModal(): void;
  onChange: (count: number) => void;
  commentStatuses: string[];
}

const CommentsModal = ({ open, post, highlightWords, closeModal, onChange, commentStatuses }: Props) => {
  const dispatch = useAppDispatch();
  const [postComments, setPostComments] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!open || !post) return

    const getPostComments = async () => {
      setIsLoading(true)
      const requestStatus = commentStatuses.length > 0 ? commentStatuses : ["Approved"]

      try {
        const res = await apiServices.getPostCommnets(post.id, requestStatus)
        setPostComments(res.post_comments.comments)
        onChange(res.post_comments.comments_count)
      } catch (error: any) {
        dispatch(setErrorObj(error))
      } finally {
        setIsLoading(false)
      }
    };
    getPostComments()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, post]);

  const handleClose = () => {
    closeModal()
    setIsLoading(true) //次回オープン時にモーダルがちらつかないようにする
  }

  return (
    <>
      <LoadingModal visible={isLoading && open} />
      <DisplayModal
        open={!isLoading && open}
        title={post.title}
        subtitle={`${T("mng_post_comment")}`}
        highlightWords={highlightWords}
        sx={styles.container}
        onClose={handleClose}>

        <List sx={styles.commentArea}>
          {postComments.map((comment: any, i: number) => (
            <ListItem key={i}>
              <Box>
                <CommentDetail
                  comment={comment}
                  highlightWords={highlightWords}
                />
              </Box>

              {comment.children?.length > 0 &&
                comment.children.map((childComment: any, j: number) => (
                  <Box key={j} sx={styles.childComment}>
                    <CommentDetail
                      comment={childComment}
                      highlightWords={highlightWords}
                    />

                    {childComment.children?.length > 0 &&
                      childComment.children.map((grandchildComment: any) => (
                        <Box key={grandchildComment.id} sx={styles.grandchildComment}>
                          <CommentDetail
                            comment={grandchildComment}
                            highlightWords={highlightWords}
                          />
                        </Box>
                      ))
                    }
                  </Box>
                ))
              }
            </ListItem>
          ))}
        </List>
      </DisplayModal>
    </>
  );
};

export default CommentsModal;

const styles = {
  container: {
    width: "50%"
  },

  commentArea: {
    overflow: "auto",
    marginTop: 3,
    "& .MuiListItem-root": {
      display: "block"
    }
  },

  childComment: {
    marginBottom: 2,
    marginLeft: 5
  },

  grandchildComment: {
    marginLeft: 2,
    marginTop: 1
  }
}